import { LinkPill } from '@/components/EditorPill'
import { NewspaperIcon } from '@ttab/elephant-ui/icons'
import { useContentSources } from '@/hooks/useContentSources'
import type { YDocument } from '@/modules/yjs/hooks'
import type { JSX } from 'react'
import type * as Y from 'yjs'
import { useTranslation } from 'react-i18next'

const CONTENT_SOURCE_PATH = 'links.core/content-source'

/**
 * Content source on the editor surface itself, opposite the byline, for the
 * same reason the byline moved out of the meta sheet: a field hidden behind a
 * side panel gets forgotten. Nothing is prefilled here either.
 */
export const EditorContentSource = ({ ydoc, readOnly }: {
  ydoc: YDocument<Y.Map<unknown>>
  readOnly?: boolean
}): JSX.Element => {
  const { t } = useTranslation('metaSheet')
  const options = useContentSources().map((contentSource) => {
    return {
      value: contentSource.uri,
      label: contentSource.title
    }
  })

  return (
    <LinkPill
      ydoc={ydoc}
      readOnly={readOnly}
      field='content-source'
      path={CONTENT_SOURCE_PATH}
      blockType='core/content-source'
      rel='source'
      idKey='uri'
      options={options}
      Icon={NewspaperIcon}
      addLabel={t('placeholders.addSource')}
      emptyLabel={t('misc.noSource')}
    />
  )
}
